import { UseQueryResult, useQuery } from "@tanstack/react-query";
import {
  SpendInsightsSettings,
  spendInsightsSettingsSchema,
} from "api/schema/productSettings/spendInsightsSettingsSchema";
import React, { createContext, useContext } from "react";
import Cookies from "universal-cookie";

import { CLIENT_ID_COOKIE_KEY } from "config/auth";

import { usePublicApiService } from "./PublicApiServiceProvider";

type SpendInsightsProductSettingsContextType = Pick<
  UseQueryResult<SpendInsightsSettings>,
  "data" | "error" | "isError" | "isLoading"
>;

export const SpendInsightsProductSettingsContext =
  createContext<SpendInsightsProductSettingsContextType>(
    {} as SpendInsightsProductSettingsContextType
  );

const cookies = new Cookies();

export const SpendInsightsProductSettingsContextProvider = ({
  children,
}: React.PropsWithChildren) => {
  const publicApi = usePublicApiService();

  const clientId = cookies.get(CLIENT_ID_COOKIE_KEY);
  const productKey = "supplier-enablement";

  const { data, error, isError, isLoading } = useQuery({
    enabled: !!clientId,
    queryKey: ["getSpendInsightsSettings", { productKey }],
    queryFn: () =>
      publicApi.getProductSettings<SpendInsightsSettings>(
        { productKey },
        { responseSchema: spendInsightsSettingsSchema }
      ),
  });

  return (
    <SpendInsightsProductSettingsContext.Provider
      value={{ data, isError, error, isLoading }}
    >
      {children}
    </SpendInsightsProductSettingsContext.Provider>
  );
};

export const useSpendInsightsProductSettings = () =>
  useContext(SpendInsightsProductSettingsContext);
